<app-card 
    #card 
    [cardTitle]="'LOGIN.LANGUAGE' | translate" 
    [formGroup]="languageForm"
    *ngIf="model$ | async as model" 
    (ok)="save()">

    <div class="flex-vertical" slot="edit">
        <mat-form-field appearance="outline" class="w-100">
            <mat-label>{{ 'LOGIN.LANGUAGE' | translate }}</mat-label>
            <mat-select formControlName="language">
                <mat-option *ngFor="let lang of supportedLanguages" [value]="lang.code">{{ lang.name }}</mat-option>
            </mat-select>
        </mat-form-field>
    </div>

    <div class="flex-vertical" slot="readonly">
        <app-read-only-field icon="language" [label]="'LOGIN.LANGUAGE' | translate" [value]="getLanguageName(model.languageCode)"></app-read-only-field>
    </div>
</app-card>
